// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"223":"34f2ec02a65db5a089cd","678":"ee8b2a07fd7fab724775","843":"58db261319051338a696","883":"9780531b074346ba765f"}[chunkId] + ".js";
};